import { render, staticRenderFns } from "./AppContentBlockImage.vue?vue&type=template&id=470c2e64&scoped=true&"
import script from "./AppContentBlockImage.vue?vue&type=script&lang=js&"
export * from "./AppContentBlockImage.vue?vue&type=script&lang=js&"
import style0 from "./AppContentBlockImage.vue?vue&type=style&index=0&id=470c2e64&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470c2e64",
  null
  
)

export default component.exports